import React from 'react';
import { guid }  from '../utils';
import jsPDF from "jspdf";
import ButtonIcon from '../../components/commons/ButtonIcon';
import Swal from 'sweetalert2';
import Loader from '../../components/commons/Loader';
import { history } from '../../routes';
import config from '../../config';

export default class PDFExportButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pdfCreated: false,
      creatingPDF: false,
    }
  }

  componentDidMount() {
    if(this.props.autoDownload){
      this.autoDownload()
    }
  }

  autoDownload = async () => {
    const { title = 'DOWNLOAD', file_title = "title", data, filename = guid() + '.pdf', className = null, htmlId, orientation = 'portrait', icon } = this.props
    const { pdfCreated, creatingPDF } = this.state;
    await this.autoCreatePDF(pdfCreated,file_title,filename,htmlId)
    history.push(config.ROUTES.VERIFY_PRESCRIPTION.replace(":id", this.props.prescription_id))
  }

  exportPDFHTML = async (title, filename, id) => {
    this.setState({creatingPDF:true})

    const unit = "pt";
    const size = "A4"; 
    
    const marginLeft = 30;
    const doc = new jsPDF("portrait", unit, size);

    doc.setFontSize(10);
    const element = document.getElementById(id)
    await doc.html(element, {
        callback: function (doc) {
          //doc.save(filename);
        },
        x: 20,
        y: 0
     });
      
     const openURL = doc.output('bloburl', { filename: filename })
     this.setState({openURL})
     this.setState({fnDownload: () => {doc.save(filename)}})
     this.setState({pdfCreated:true}) 
     this.setState({creatingPDF:false})
  }
  
  onClick = async (pdfCreated,file_title,filename,htmlId) => {
    if(!pdfCreated){
      await this.exportPDFHTML(file_title,filename,htmlId)
    }
    const swalWithStyle = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary mr-2',
        denyButton: 'btn btn-outline btn-primary mr-2',
        cancelButton: 'btn btn-ghost',
      },
      buttonsStyling: false
    })
    swalWithStyle.fire({
      text: "¿Desea abrir o descargar el archivo PDF?",
      icon: 'question',
      showCancelButton: true,
      showDenyButton: true,
      confirmButtonText: 'Abrir',
      denyButtonText: 'Descargar',
      cancelButtonText: 'Cancelar',
    })
    .then((result) => {
      if (result.isConfirmed) {
        window.open(this.state.openURL)
      }
      if (result.isDenied) {
        this.state.fnDownload()
      }
    });
  }

  autoCreatePDF = async (pdfCreated,file_title,filename,htmlId) => {
    if(!pdfCreated){
      await this.exportPDFHTML(file_title,filename,htmlId)
    }
    this.state.fnDownload()
  }

  render() {
    const { title = 'DOWNLOAD', file_title = "title", data, filename = guid() + '.pdf', className = null, htmlId, orientation = 'portrait', icon } = this.props
    const { pdfCreated, creatingPDF } = this.state;
    return icon ? (
      <>      
        <ButtonIcon buttonClassName="btn-ghost mr-1" icon="download" disabled={creatingPDF}
          onClick={() => this.onClick(pdfCreated,file_title,filename,htmlId)}
        />
        {creatingPDF && <Loader size="mini"/>}
      </>
    ) : (
      <button onClick={()=> this.exportPDFHTML(file_title,filename,htmlId)}>
        {title}
      </button>
    )
  }
}

